import { render, staticRenderFns } from "./TableLogoHeader.vue?vue&type=template&id=1e9501e0&"
import script from "./TableLogoHeader.vue?vue&type=script&lang=ts&"
export * from "./TableLogoHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports